import { defineMessages } from "react-intl";

import {
	hbvCurrentStateMessages,
	hbvTreatedEverMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/chronic-liver-failure/chronicLiverFailureHbv";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	chronicLiverFailureHbv: {
		id: "ktx.form.chronic_liver_failure_hbv",
		defaultMessage: "HBV"
	},
	currentState: {
		id: "ktx.form.chronic_liver_failure_hbv.current_state",
		defaultMessage: "Jelenlegi státusz"
	},
	hbvTreatedEver: {
		id: "ktx.form.chronic_liver_failure_hbv.treated_ever",
		defaultMessage: "Kezelést kapott-e valaha?"
	},
	hbvTreatedComment: {
		id: "ktx.form.chronic_liver_failure_hbv.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	hbvCurrentState: {
		type: "field",
		path: ["hbvCurrentState"],
		label: messages.currentState,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: hbvCurrentStateMessages }
		}
	},
	hbvTreatedEver: {
		type: "field",
		path: ["hbvTreatedEver"],
		label: messages.hbvTreatedEver,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: hbvTreatedEverMessages }
		}
	},
	hbvTreatedComment: {
		type: "field",
		path: ["hbvTreatedComment"],
		label: messages.hbvTreatedComment,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.hbvCurrentState }] },
		{ columns: [{ width: 12, field: fields.hbvTreatedEver }] },
		{ columns: [{ width: 12, field: fields.hbvTreatedComment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_chronicLiverFailureHbv",
	value: {
		schemaId: "chronicLiverFailureHbv",
		title: messages.chronicLiverFailureHbv,
		validator,
		fieldset,
		applyCurrentDate: true,
		defaults: [
			{
				path: [],
				query: {
					interpretation: {
						vocab: "ktx",
						code: "hbv_chronic_liver_failure_statement"
					}
				}
			}
		]
	}
};
